import BaseInputControl from "./BaseInputControl";
import type { HandleInputChange } from "./types";

type TextInputProps = {
    name: string;
    value?: string | number;
    placeholder?: string;
    disabled?: boolean;
    onChange: HandleInputChange;
};

const TextInput = ({ name, value, placeholder, disabled, onChange }: TextInputProps) => {
    return (
        <BaseInputControl
            type="text"
            name={name}
            value={value}
            placeholder={placeholder}
            disabled={disabled}
            onChange={onChange}
        />
    );
};

export default TextInput;
